var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge rounded-pill font-size-11",class:{
          'badge-soft-info': _vm.status === 'loaded',
          'badge-soft-success': _vm.status === 'delivered',
          'badge-soft-warning': _vm.status === 'not loaded',
          'badge-soft-danger': _vm.status === 'cancelled',
          'badge-soft-secondary': _vm.status === 'open',
          'badge-soft-dark': _vm.status === 'returned',
        }},[_vm._v(" "+_vm._s(_vm.order_status))])
}
var staticRenderFns = []

export { render, staticRenderFns }